import { render } from "./FooterContainer.vue?vue&type=template&id=158c31ba&scoped=true&bindings={\"width\":\"props\",\"height\":\"props\",\"align\":\"props\",\"pt\":\"props\",\"pb\":\"props\",\"pl\":\"props\",\"pr\":\"props\",\"padding\":\"props\",\"background\":\"props\"}"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"

import "./FooterContainer.vue?vue&type=style&index=0&id=158c31ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-158c31ba"

export default script